export default "__VITE_ASSET__b5e888cb__"